<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/plan-validation-rules" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.CreateValidationRule") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.InputPlanId")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.InputPlanId')"
                >
                  <v-select
                    v-if="filteredInputPlans || template && template.planList"
                    label="planDescription"
                    :options="
                      filteredInputPlans
                        ? filteredInputPlans
                        : template.planList
                    "
                    v-model="inputPlanId"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :reduce="(obj) => obj.id"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.CheckinPlanId")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.CheckinPlanId')"
                >
                  <v-select
                    label="planDescription"
                    v-if="filteredCheckinPlans || template && template.planList"
                    :options="
                      filteredCheckinPlans
                        ? filteredCheckinPlans
                        : template.planList
                    "
                    v-model="checkinPlanId"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(obj) => obj.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.RuleAppliesTo")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.RuleAppliesTo')"
                >
                  <v-select
                    label="mCodeValue"
                    v-if="template && template.ruleAppliestoList"
                    :options="template.ruleAppliestoList"
                    v-model="ruleAppliesTo"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :reduce="(obj) => obj.id"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.Rule")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Rule')"
                >
                  <v-select
                    label="mCodeValue"
                    v-if="template && template.ruleExpressionList"
                    :options="template.ruleExpressionList"
                    v-model="rule"
                    :reduce="(obj) => obj.id"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createTeamData"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ValidationPopup from "@/components/ValidationPopup.vue";

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      inputPlanId: "",
      checkinPlanId: "",
      ruleAppliesTo: "",
      rule: "",
    };
  },
  components: {
    "v-select": vSelect,
    "validation-popup": ValidationPopup,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      template: (state) => state.planValidationRules.validationRuleTemplate,
    }),
    filteredCheckinPlans() {
      if (this.inputPlanId) {
        return this.template.planList.filter(
          (plan) => plan.id !== this.inputPlanId
        );
      }
    },
    filteredInputPlans() {
      if (this.checkinPlanId) {
        return this.template.planList.filter(
          (plan) => plan.id !== this.checkinPlanId
        );
      }
    },
  },
  methods: {
    async createTeamData() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        const payload = {
          inputPlanId: this.inputPlanId,
          checkinPlanId: this.checkinPlanId,
          ruleAppliesTo: this.ruleAppliesTo,
          rule: this.rule,
        };

        await this.$store.dispatch(
          "planValidationRules/createPlanValidationRuleAction",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Validation Rule Created Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/plan-validation-rules`);
        this.resetForm();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getTemplateData() {
      try {
        await this.$store.dispatch(
          "planValidationRules/getPlanValidationRulesTemplateAction"
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    resetForm() {
      this.inputPlanId = "";
      this.checkinPlanId = "";
      this.ruleAppliesTo = "";
      this.rule = "";
      this.$refs.observer.reset();
    },
    cancel() {
      this.$router.push("/setup/plan-validation-rules");
    },
  },
  watch: {},
  async mounted() {
    this.resetForm();
    await this.getTemplateData();
  },
};
</script>
